import ConfigurationManager from '../_configuration/ConfigurationManager';
import HttpMethod from '../_utils/HttpMethod';
import URIBuilder from '../_utils/URIBuilder';

const SEARCH_PATH = '/search';
const COUNT_PATH = '/count';
const UPDATE_PATH = '/';

class WFTaskClient {
    searchByStatus(status, projectId, apiKey, limit = 10, offset = 0) {
        let headers = new Headers();
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        headers.append('apiKey', apiKey);
        headers.append('X-Api-Key', ConfigurationManager.getProperty('WF_TASK_API_X_API_KEY'));

        let configuration = {};
        configuration.method = HttpMethod.GET;
        configuration.headers = headers;

        let uri = new URIBuilder(ConfigurationManager.getProperty('WF_TASK_API_HOST'));
        uri.path = `${ConfigurationManager.getProperty('WF_TASK_API_BASE_PATH')}${SEARCH_PATH}`;
        uri.addParam('projectID', projectId);
        uri.addParam('status', status);
        uri.addParam('status_Mod', 'eq');
        uri.addParam('fields', 'parameterValues,lastNote:name,entryDate');
        uri.addParam('$$LIMIT', limit);
        uri.addParam('$$FIRST', offset);

        let request = new Request(uri.toString(), configuration);
        return fetch(request).then(res => res.json());
    }

    countByStatus(status, projectId, apiKey) {
        let headers = new Headers();
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        headers.append('apiKey', apiKey);
        headers.append('X-Api-Key', ConfigurationManager.getProperty('WF_TASK_API_X_API_KEY'));

        let configuration = {};
        configuration.method = HttpMethod.GET;
        configuration.headers = headers;

        let uri = new URIBuilder(ConfigurationManager.getProperty('WF_TASK_API_HOST'));
        uri.path = `${ConfigurationManager.getProperty('WF_TASK_API_BASE_PATH')}${COUNT_PATH}`;
        uri.addParam('projectID', projectId);
        uri.addParam('status', status);
        uri.addParam('status_Mod', 'eq');

        let request = new Request(uri.toString(), configuration);
        return fetch(request).then(res => res.json());
    }

    updateStatus(taskId, status, apiKey) {
        let headers = new Headers();
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        headers.append('apiKey', apiKey);
        headers.append('X-Api-Key', ConfigurationManager.getProperty('WF_TASK_API_X_API_KEY'));

        let body = {
            status: status
        }

        let configuration = {};
        configuration.method = HttpMethod.PUT;
        configuration.headers = headers;
        configuration.body = JSON.stringify(body);

        let uri = new URIBuilder(ConfigurationManager.getProperty('WF_TASK_API_HOST'));
        uri.path = `${ConfigurationManager.getProperty('WF_TASK_API_BASE_PATH')}${UPDATE_PATH}${taskId}`;

        let request = new Request(uri.toString(), configuration);
        return fetch(request).then(res => res.json());
    }

}

export default WFTaskClient;


// WEBPACK FOOTER //
// ./src/_clients/WFTaskClient.js